import { gql } from '@apollo/client'

export const getShippingMethodsQuery = gql`
  query ShippingMethods($id: ID!) {
    cartShippingMethods(id: $id) {
      bag_id
      shipping_methods {
        shipping_method_id
        type
        carrier
        label
        price
      }
    }
  }
`
